export class TreeItem<TKey, TValue> {
  key: TKey;
  parentKey?: TKey;
  data?: TValue;
  children?: TreeItem<TKey, TValue>[];
  expanded?: boolean;
}
